<div id="cont">
  <div>
    <span>{{ "Account deletion can be requested in the user's profile" | translate }}</span>: <a [routerLink]="['/', 'account']">{{ home_base }}/account</a>
  </div>
  <div>
    <span>{{ 'or by contacting us at' | translate }}: </span>
    <a href="mailto:{{support_email}}">{{ support_email }}</a>
  </div>
</div>
